import { createTheme } from '@material-ui/core/styles';

export const posTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#00638D',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#3f4a51',
            contrastText: '#FFFFFF',
        },
        divider: '#007FB6',
    },
});
